/**
 * table
 *
 * @author Shigq
 * @date 2021/4/19 15:56
 */
import { reactive } from 'vue'
import { pagination } from '@/config'

export default function() {
  // todo - global param
  const { currentPage, pageSize, total } = pagination

  // todo - methods
  const scopedMethods = {
    /**
     * createTable table
     *
     * @param columns
     * @returns {*}
     */
    createTable: ({ columns = [] } = {}) => {
      const _data = reactive({
        list: [],
        loading: false
      })

      const _pagination = reactive({
        currentPage: currentPage,
        pageSize: pageSize,
        total: total
      })

      return reactive({
        data: _data,
        pagination: _pagination,
        columns
      })
    }
  }

  return {
    ...scopedMethods
  }
}
